var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabPanel',{staticClass:"panel",attrs:{"value":"devices"}},[_c('DevicesTable',{attrs:{"is-loading":_vm.isLoading,"data":_vm.deviceData,"has-results":_vm.hasResults,"series":_vm.series,"data-title":"Clicks","hide-unique":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }